import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CheckoutService} from '../services/checkout.service';
import {environment} from '../../environments/environment';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {CreditCardValidator} from 'ngx-credit-cards';
import {ParticipateService} from '../services/participate.service';
import {SpinnerVisibilityService} from 'ng-http-loader/services/spinner-visibility.service';
import {MatDialog} from '@angular/material';
import {Meta} from '@angular/platform-browser';
import {DialogErrorComponent} from '../dialog-error/dialog-error.component';


@Component({
  selector: 'app-participate',
  templateUrl: './participate.component.html',
  styleUrls: ['./participate.component.styl']
})
export class ParticipateComponent implements OnInit, OnDestroy {


  now: Date = new Date();
  timer_date = null;
  purchase = {
    total_value: 0,
    current_value: 0,
    suggested_participation: 0,
    description: '',
    extra_description: null,
    pay_limit_date: null,
    verify: false,
    customer: {
      document_number: '',
      name: '',
      main_img: '',
      url: ''
    },
    owner: {
      first_name: '',
      last_name: '',
      email: ''
    }
  };
  participation_value = 0;
  purchase_id = '';
  document_types = [];
  info_form: FormGroup;
  participation_form: FormGroup;
  card_form: FormGroup;
  pse_form: FormGroup;
  payment_method = 'none';
  placeholders_card: any = {number: '•••• •••• •••• ••••', name: 'nombre tarjeta', expiry: '••/••', cvc: '•••'};
  messages_card: any = {validDate: 'valid\ndate', monthYear: 'mm/yy'};
  @ViewChild('numberCard') number_card: ElementRef;
  modal_pse = false;
  penging_payment = false;
  before_payment_id = '';
  min_payment_value = 1000;


  Array = Array;
  Math = Math;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private _formBuilder: FormBuilder,
              private checkoutService: CheckoutService,
              private participateService: ParticipateService,
              private spinner: SpinnerVisibilityService,
              public dialog: MatDialog,
              private meta: Meta) {
  }

  ngOnInit() {
    this.addTagsHead();
    this.getPurchase();
    this.configForms();
    this.timer_date = setInterval(() => {
      this.now = new Date();
    }, 1000);
    this.document_types = environment.document_types;
  }

  ngOnDestroy() {
    this.removeTagsHead();
  }

  selectPayment(payment) {
    this.payment_method = payment;
  }

  getPurchase(): void {
    this.route.params.subscribe((params) => {
      this.purchase_id = params.purchaseId;
      this.checkoutService.getPurchase(params.purchaseId)
        .subscribe(purchase => {
            this.purchase = purchase;
            if (purchase.pay_limit_date) {
              this.purchase.pay_limit_date = new Date(purchase.pay_limit_date);
            }
            this.participation_form.get('total_value').setValidators([
              Validators.required,
              Validators.min(this.min_payment_value),
              this.maxValueParticipationValidator(purchase)
            ]);
            this.participation_value = purchase.total_value - purchase.current_value < purchase.suggested_participation ?
              purchase.total_value - purchase.current_value : purchase.suggested_participation;
          },
          error => {
            console.log(error);
            this.router.navigate(['404']);
          });
    });

  }

  getNameDocument(value) {
    let final_value = '';
    this.document_types.map((x) => {
      if (x.value === value) {
        final_value = x.name;
      }
    });
    return final_value;
  }

  paymentGateway() {
    const request = {
      first_name: this.info_form.get('first_name').value,
      last_name: this.info_form.get('last_name').value,
      email: this.info_form.get('email').value,
      cellphone: this.info_form.get('cellphone').value,
      purchase_id: this.route.snapshot.params['purchaseId'],
      total_value: this.participation_form.get('total_value').value,
      force_payment_pending: false,
    };
    switch (this.payment_method) {
      case 'pse':
        request['payment_method'] = environment.pse_payment_method;
        request['document_type'] = this.info_form.get('document_type').value;
        request['document_number'] = this.info_form.get('document_number').value;
        break;
      case 'card':
        request['document_type'] = this.info_form.get('document_type').value;
        request['document_number'] = this.info_form.get('document_number').value;
        request['payment_method'] = environment.card_payment_method;
        request['card_installments'] = this.card_form.get('card_installments').value;
        request['card_number'] = this.card_form.get('card_number').value.replace(/ /g, '');
        request['card_type'] = this.getTypeCard();
        request['card_month'] = (this.card_form.get('card_expiry').value.replace(/ /g, '')).split('/')[0];
        request['card_year'] = (this.card_form.get('card_expiry').value.replace(/ /g, '')).split('/')[1].length === 4 ?
          (this.card_form.get('card_expiry').value.replace(/ /g, '')).split('/')[1].slice(-2) :
          (this.card_form.get('card_expiry').value.replace(/ /g, '')).split('/')[1];
        request['card_name'] = this.card_form.get('card_name').value;
        request['card_cvc'] = this.card_form.get('card_cvc').value;
        break;
    }
    this.participateService.createParticipation(request).subscribe((data: any) => {
      if (data.valid) {
        switch (this.payment_method) {
          case 'pse':
            this.modal_pse = true;
            document.location.href = environment.zona_pagos_url_pse + data.zona_virtual_id;
            break;
          case 'card':
            this.router.navigate(['participate-response'], {queryParams: {id_pago: data.payment_id}});
            break;
        }
      } else {
        if (data.pending) {
          this.penging_payment = true;
          this.before_payment_id = data.before_payment_id;
        } else {
          if (data.invalid_amount) {
            this.dialog.open(DialogErrorComponent, {
              data: {
                message: '¡El monto a pagar no es válido, ingresa otro valor!' + '<br><br>' +
                'Recuerda que si no estás pagando el saldo restante, se deben dejar por lo menos $10.000 para el siguiente pago.'
              }
            });
          }
        }
      }
    }, (err: any) => {
      if (err.status === 403) {
        this.dialog.open(DialogErrorComponent, {
          data: {
            message: 'Ha ocurrido un error con los datos ingresados, para mas información contáctanos a ' +
            '<a href="mailto:info@wenjoy.com.co">' +
            '<strong>info@wenjoy.com.co</strong></a>'
          }
        });
      }
    });
  }

  private addTagsHead() {
    // this.meta.addTag({property: 'og:site-name', content: 'Wenjoy'});
    // this.meta.addTag({property: 'og:title', content: 'Paga con Wenjoy'});
    // this.meta.addTag({property: 'og:description', content: 'Participa en una compra'});
    // this.meta.addTag({property: 'og:image', content: 'https://wenjoy.com.co/assets/img/logo.png'});
    // this.meta.addTag({property: 'og:type', content: 'website'});
  }

  private removeTagsHead() {
    // this.meta.removeTag('property="og:site-name"');
    // this.meta.removeTag('property="og:title"');
    // this.meta.removeTag('property="og:description"');
    // this.meta.removeTag('property="og:image"');
    // this.meta.removeTag('property="og:type"');

  }

  private maxValueParticipationValidator(purchase: any): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (Number(control.value) === (purchase.total_value - purchase.current_value) ||
        Number(control.value) <= ((purchase.total_value - purchase.current_value) - this.min_payment_value)) {
        return null;
      }
      return {'maxValueParticipation': false};
    };

  }

  private getTypeCard() {
    let value = environment.card_default_type;
    environment.card_types.map((x) => {
      if (this.number_card.nativeElement.classList.contains(x.name)) {
        value = x.value;
      }
    });
    return value;
  }

  private configForms() {
    this.info_form = this._formBuilder.group({
      email: ['email' in this.route.snapshot.queryParams ? this.route.snapshot.queryParams['email'] : '',
        [Validators.required, Validators.email]],
      first_name: ['first_name' in this.route.snapshot.queryParams ? this.route.snapshot.queryParams['first_name'] : '',
        [Validators.required]],
      last_name: ['last_name' in this.route.snapshot.queryParams ? this.route.snapshot.queryParams['last_name'] : '',
        [Validators.required]],
      cellphone: ['cellphone' in this.route.snapshot.queryParams ? Number.parseInt(this.route.snapshot.queryParams['cellphone']) : null,
        [Validators.required, Validators.minLength(7)]],
      document_number: ['document_number' in this.route.snapshot.queryParams ?
        Number.parseInt(this.route.snapshot.queryParams['document_number']) : null,
        [Validators.required]],
      document_type: ['document_number' in this.route.snapshot.queryParams ?
        Number.parseInt(this.route.snapshot.queryParams['document_type']) : 1,
        [Validators.required]],
    });
    this.participation_form = this._formBuilder.group({
      total_value: [null, []]
    });
    this.card_form = this._formBuilder.group({
      card_installments: [null, [Validators.required]],
      card_number: [null, [CreditCardValidator.validateCardNumber]],
      card_expiry: ['', [CreditCardValidator.validateCardExpiry]],
      card_name: ['', [Validators.required, Validators.minLength(2)]],
      card_cvc: [null, [CreditCardValidator.validateCardCvc]],
    });
    this.pse_form = this._formBuilder.group({});
  }

  backToCommerce() {
    document.location.href = this.purchase.customer.url;
  }

  getRestTime(now_time, future_time) {

    let delta = Math.abs(future_time - now_time) / 1000;

    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    const seconds = Math.floor(delta % 60);

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };

  }
}



// WEBPACK FOOTER //
// ./src/app/participate/participate.component.ts